import { render, staticRenderFns } from "./InsuranceProgramReestrImport.vue?vue&type=template&id=a256fd7e&scoped=true"
import script from "./InsuranceProgramReestrImport.vue?vue&type=script&lang=js"
export * from "./InsuranceProgramReestrImport.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProgramReestrImport.vue?vue&type=style&index=0&id=a256fd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a256fd7e",
  null
  
)

export default component.exports